webpackJsonp([65850540693356],{

/***/ 2127:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"Float","kind":"SCALAR","type":"OBJECT","fields":null,"description":"The `Float` scalar type represents signed double-precision fractional\nvalues as specified by\n[IEEE 754](https://en.wikipedia.org/wiki/IEEE_754).","enumValues":null,"possibleTypes":null}}

/***/ })

});


// WEBPACK FOOTER //
// path---scalar-float-cbecabcfe27faa7bc814.js